module.exports = __webpack_public_path__ + "static/media/notifClock.3c11f035.svg";